import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { authApi } from "../lib/auth";

// Handles the #session_id=... fragment returned by Emergent Google Auth.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/");
      return;
    }

    authApi
      .post("/auth/session", { session_id: sessionId })
      .then((res) => {
        const user = res.data;
        window.history.replaceState(null, "", window.location.pathname);
        if (user.role === "admin") {
          navigate("/admin-pod", { state: { user } });
        } else if (user.role === "label_scanner") {
          navigate("/label-scan", { state: { user } });
        } else {
          navigate("/pod-portal", { state: { user } });
        }
      })
      .catch(() => {
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/pod-portal");
      });
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-3">
        <div className="w-10 h-10 border-4 border-slate-950 border-t-[#FFD400] rounded-full animate-spin" />
        <p className="text-sm font-mono uppercase tracking-widest text-slate-500">Signing you in…</p>
      </div>
    </div>
  );
}
